import React from "react";
import { StrapiMedia } from "../../types/strapi";
import VideoFullScreen from "./VideoFullScreen";
import VideoFullWidth from "./VideoFullWidth";
import VideoStandard from "./VideoStandard";

interface VideoData {
  url?: string;
  start?: string | null;
  videoFile?: StrapiMedia | null;
}

interface VideoProps {
  elementId?: string;
  type?: string;
  videoData?: VideoData;
  vidImg?: string;
  cssClass?: string;
}

const Video: React.FC<VideoProps> = ({
  elementId = "",
  type,
  videoData,
  vidImg,
  cssClass,
}) => {
  if (videoData) {
    if (type === "fullScreen" && videoData.url && videoData.url !== "") {
      return (
        <div className="mb-xl-5">
          <VideoFullScreen
            elementId={elementId}
            url={videoData.url.trim().replace("https://vimeo.com/", "")}
          />
        </div>
      );
    }

    if (type === "fullWidth") {
      return (
        <div className="mb-xl-5">
          <VideoFullWidth
            elementId={elementId}
            url={
              videoData.videoFile?.url
                ? videoData.videoFile.url
                : videoData.url
            }
          />
        </div>
      );
    }

    if (type === "standard" && videoData.url && videoData?.url !== "") {
      return (
        <VideoStandard
          elementId={elementId}
          cssClass={cssClass}
          start={videoData.start ?? ""}
          url={videoData.url}
          vidImg={vidImg}
        />
      );
    }
  }

  return "";
};

export default Video;
